<template>
  <div class="wlx-site-manager-wrapper">
    <header class="site-manager-head-con">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="title" placeholder="会议标题" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getEnrollList()">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>

    <el-table :data="EnrollList" @selection-change="handleSelectionChange" style="width: 100%">
      <el-table-column prop="Id" type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column prop="title" label="会议标题" show-overflow-tooltip></el-table-column>
      <el-table-column prop="companyName" label="单位" show-overflow-tooltip></el-table-column>
      <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
      <el-table-column prop="zipCode" label="邮编" show-overflow-tooltip></el-table-column>
      <el-table-column prop="invoice" label="发票抬头" show-overflow-tooltip></el-table-column>
      <el-table-column prop="taxNumber" label="纳税人识别号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="dateCreated" label="报名时间" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="220px">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="goLook(scope.row.id)">编辑</el-button>
          <a
            type="primary"
            size="mini"
            :href="exprotHref + scope.row.id"
            class="export-table-btn"
          >导出报名表格</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="u-page-con">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        v-show="totalCount>0"
        style="text-align: center;"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      EnrollList: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      exprotHref: "/api/XOrg/MeetingEnroll/eportMeetingEnroll?MeetingEnrollId="
    };
  },
  components: {},
  computed: {
    userInfo() {
      return this.$store.state.auth;
    }
  },
  created() {
    this.getEnrollList();
  },
  methods: {
    goLook(id) {
      this.$router.push({
        name: "signTableEdit",
        params: {
          signUpId: id
        }
      });
    },
    handleSelectionChange() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getEnrollList();
    },
    onPageChangeHandler(val) {
      this.page = val;
      this.getEnrollList();
    },
    getEnrollList() {
      var that = this;
      this.$http
        .post("/api/XOrg/MeetingEnroll/getEnrollList", {
          title: that.title,
          PageSize: that.pageSize,
          page: that.page
        })
        .then(rst => {
          if (rst.code > 0) {
            that.EnrollList = rst.list;
            that.page = rst.pagination.pageIndex;
            that.pageSize = rst.pagination.pageSize;
            that.totalCount = rst.pagination.totalCount;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
  padding: 20px 30px 0 30px;
  // padding: 20px;
  // background: #fff;
  .el-input--suffix .el-input__inner {
    padding-right: 30px;
    height: 34px;
  }
  .export-table-btn {
  
    margin-left: 10px;
    color: #fff;
    padding: 7px 15px;
    background-color: #409eff;
    border-radius: 3px;
    font-size: 12px;
  }
}
</style>
